const { hostname } = window.location;

export const isLocal =
  hostname === 'localhost' || hostname.endsWith('.samera.one.localhost');
export const oneIdentifier =
  hostname === 'localhost' ? 'test' : hostname.split('.')[0];
export const isStaging = hostname.includes('.staging.');

export type Environment = 'local' | 'staging' | 'production' | 'dev';

/**
 * Maps a hostname to the deployment environment.
 *
 * Every test is positive: a host only counts as production or staging when it
 * ends with the domain we actually deploy to. `isStaging` above is deliberately
 * NOT reused here — it matches any host containing `.staging.`, including ones
 * we do not own, and telemetry routing must fail closed rather than open.
 * Anything unrecognised is `dev`, which has no collector.
 *
 * Order matters: `*.staging.samera.one` also ends with `.samera.one`.
 */
export const getEnvironment = (host: string = hostname): Environment => {
  if (host === 'localhost' || host.endsWith('.samera.one.localhost')) {
    return 'local';
  }
  if (host.endsWith('.staging.samera.one')) return 'staging';
  if (host.endsWith('.samera.one')) return 'production';
  return 'dev';
};
